<template>
  <div>

    <v-navigation-drawer fixed v-model="mobileSidebar" :mini-variant.sync="getMiniSidebar" app style="top: 49px;height: 93.8vh;" >

      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>
            <span>
              {{ $t('hello') }} <span class="font-weight-medium">{{getUser.full_name}}</span> <br/>
              <span class="font-weight-medium" style="font-size: 10px">
                {{getUser.email}}
              </span>
            </span>
            <div class="mt-1">
              <span v-if="getUser.super_admin" style="font-size: 10px">
                <v-chip color="error" label x-small text-color="white">{{ $t('superAdmin') }}</v-chip>
              </span>
              <span v-if="!getUser.super_admin && getUser.center_id" style="font-size: 10px">
                <v-chip color="green" label x-small text-color="white">{{ getRoleName }}</v-chip>
              </span>
            </div>

          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <template v-if="!getUser.super_admin && getUser.additional_centers && getUser.additional_centers.length > 0">
        <v-divider></v-divider>
        <SwitchCentro :user="getUser"/>
      </template>

      <div
          @click="reloadNoCache"
          style="font-size: 10px; margin: 0 4px 0 0; display: block; text-align: right; cursor: pointer;"
          title="Forza ricarica senza cache"
      >
        <span>ver. 1.4.3</span>
      </div>

      <v-divider></v-divider>

      <MenuLeft></MenuLeft>

      <template v-slot:append>
        <div class="pa-2" v-if="!getMiniSidebar">
          <v-btn block @click="tryLogout" color="primary">
            {{ $t('logout') }}
          </v-btn>
        </div>
        <div class="pa-2" v-else>
          <v-btn block @click="tryLogout" color="primary" :title="$t('logout') ">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </div>
      </template>

    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import MenuLeft from "@/components/layout/MenuLeft.vue";
import SwitchCentro from "@/components/layout/SwitchCentro.vue";

export default {
  name: "LeftToolbar",
  components: {SwitchCentro, MenuLeft},
  computed: {
    ...mapGetters({
      'getMobileSidebar': 'settings/getMobileSidebar',
      'getMiniSidebar': 'settings/getMiniSidebar',
      'getUser':'user/getUser',
      'getRoleName':'user/getRoleName',
      'getRoles':'permissions/getRoles'
    }),
    mobileSidebar: {
      get: function (old, newvalue) {
        if(!this.$vuetify.breakpoint.mobile){
          return true
        }else {
          return this.getMobileSidebar;
        }
      },
      set: function (newvalue) {
        // console.log(newvalue)
        return this.setMobileSidebar(newvalue);
      }
    },
  },
  created() {

  },
  methods: {
    ...mapActions({
      'logout': 'user/logout',
    }),
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setMobileSidebar': 'settings/setMobileSidebar',
    }),
    async tryLogout() {
      this.setLoading(true)
      await this.logout()
      this.setLoading(false)
      // this.$router.push('/login');
    },
    reloadNoCache() {
      this.$root.$emit('forceReload');
    }

  }
}
</script>

<style scoped>

</style>